import { BlockStack, Box, Button, Card, InlineStack, Layout, SkeletonBodyText } from '@shopify/polaris';
import React, { useEffect, useState }  from 'react';
import "./index.css";
import ImportAliModal from './ImportAliModal';
import ImportTemuModal from './ImportTemuModal';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import utils from "../../../../utils/utils";
import EnoughQuotaModal from "../SourcingRequest/component/EnoughQuotaModal";
import EnoughPointsModal from "../SourcingRequest/component/EnoughPointsModal";
import { useSelector } from 'react-redux';
const Index  = ({
    planData,
  userPoints,
  setPremiumData,
  handleMageUpgrade,
  subList,
  planShow
})=> {
    const [aliModal,setAliModal] = useState(false)
    const [temuModal,setTemuModal] = useState(false);
    const router = useHistory();
     // 次数不足
      const [sourcingLimitModal,setSourcingLimitModal] = useState(false)
      // 达到上限
      const [enoughPoint,setEnoughPoint] = useState(false);
      const handleSubmit = (val) => {
        if (val) {
          if (val === 5) {
            setPremiumData((prevValue) => ({
                ...prevValue,
                open: true,
              }));
            setSourcingLimitModal(false)
        }
        if (val === 6) {
          handleProductImport()
          setSourcingLimitModal(false)
        }
            if (val <5) {
              handleMageUpgrade(val)
            }
        }
      };
      const plan_level = useSelector(
          (state) => state.languageReducer.subScriptData
        );
      // 产品导入 使用积分
      const handleProductImport = async () => {
        // utils.routeListen("/admin/product_management?selectedView=0&import=1&isPoints=1")
        utils.routeJump1(router,"/admin/product_management?selectedView=0&import=1&isPoints=1")
      };
     
      const [initPage,setInitPage] = useState(true)
      useEffect(()=>{
        setTimeout(() => {
          setInitPage(false)
        }, 1500);
      },[])
      const initSkeletonPage = (
          <div className="skeleton_page_children" style={{ top:'64px' }}>
            <div className="import_product_content">
              <Layout>
                <Layout.Section>
                <BlockStack gap={400}>
                  <Card>
                    <BlockStack gap={400}>
                      <SkeletonBodyText lines={3} />
                      <SkeletonBodyText lines={3} />
                      <SkeletonBodyText lines={3} />
                      <SkeletonBodyText lines={2} />
                    </BlockStack>
                  </Card>
                  <Card>
                    <BlockStack gap={400}>
                      <SkeletonBodyText lines={3} />
                      <SkeletonBodyText lines={3} />
                      <SkeletonBodyText lines={3} />
                      <SkeletonBodyText lines={3} />
                    </BlockStack>
                  </Card>
                  
                  </BlockStack>
                </Layout.Section>
              </Layout>
            </div>
          </div>
        );

      const pageContent = (
        <Box className="import_product_content">
            <BlockStack gap={400}>
            <Box>
                <Card padding={0}>
                    <InlineStack  align='space-between' blockAlign='center'>
                    <Box className="import_product_content_box">
                        <Box className="import_product_content_box_title">Seamless Import from AliExpress</Box>
                        <Box className="import_product_content_box_desc">One-click to capture comprehensive AliExpress product data via URL or Chrome extension.</Box>
                        <Box className="import_product_content_box_button">
                        <InlineStack wrap={false} gap={200} blockAlign='center' align='flex-start'>
                        <Button variant='primary' onClick={()=>setAliModal(true)} >Import from AliExpress</Button>
                        <Button  onClick={()=>{
                          if (plan_level.level === 5 || plan_level.bill_level === 5) {
                            if (
                              userPoints.userPointsData.available_points < 150 &&
                              planData.aliexpressLimit >= planData.aliexpressDay && 
                              planData.use_product >= planData.add_product
                            ) {
                                setEnoughPoint(true);
                                return;
                            }
                          }
                          if (planData.aliexpressLimit >= planData.aliexpressDay && planData.use_product >= planData.add_product) {
                            setSourcingLimitModal(true);
                            return;
                          }
                          
                          // utils.routeListen("/admin/product_management?selectedView=0&import=1&isPoints=0")
                          utils.routeJump1(router,"/admin/product_management?selectedView=0&import=1&isPoints=0")
                        }}>Add AliExpress Products</Button>
                        </InlineStack>
                        </Box>
                    </Box>
                    <Box className="import_product_content_box_image">
                        <img src="/new-product/ali_image.png" alt="Dropshipman" />
                    </Box>
                    </InlineStack>
                </Card>
            </Box>
            <Box>
                <Card padding={0}>
                <InlineStack align='space-between' blockAlign='center'>
                <Box  className="import_product_content_box">
                    <Box  className="import_product_content_box_title">One-click Import Products from Temu</Box>
                        <Box  className="import_product_content_box_desc">One-click to capture comprehensive Temu product data via Chrome extension.</Box>
                        <Box className="import_product_content_box_button">
                        <Button onClick={()=>setTemuModal(true)}>Import from Temu</Button>
                        </Box>
                    </Box>
                    <Box className="import_product_content_box_image">
                        <img src="/new-product/temu_image.png" alt="Dropshipman" />
                    </Box>
                    </InlineStack>
                </Card>
            </Box>
            </BlockStack>
            <ImportAliModal open={aliModal} setOpen={setAliModal}/>
            <ImportTemuModal open={temuModal} setOpen={setTemuModal}/>

                {/* 次数不够 */}
            <EnoughQuotaModal type={'aliexpress'} handleSubmit={handleSubmit} planShow={planShow} sourcingLimitModal={sourcingLimitModal} userPoints={userPoints} subList={subList} setSourcingLimitModal={setSourcingLimitModal}/>
            {/* 会员上限且积分不够 */}
            <EnoughPointsModal type={'aliexpress'} open={enoughPoint} setOpen={setEnoughPoint}/>
        </Box>
    )
    return (
      <div  className="skeleton_page">
        {initPage && initSkeletonPage}
      <div style={{opacity: initPage ? 0 : 1}}>
        {pageContent}
      </div>
      </div>
    );
}

export default Index;
